module.exports = __webpack_public_path__ + "fonts/tt_sushkof_regular.5e0218f.woff";